module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_wayo_studio@3x-c168a645d9752a1a579b98eab764836a.webp";